import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { pendingChangesGuard } from 'lib-trend-core';
import { ChannelFormComponent } from './channel-form/channel-form.component';
import { ChannelViewComponent } from './channel-view/channel-view.component';
import { ChannelComponent } from './channel.component';
import { ChannelRedirectInstagramComponent } from './channel-redirect-instagram/channel-redirect-instagram.component';
import { ChannelRedirectMessengerComponent } from './channel-redirect-messenger/channel-redirect-messenger.component';
import { TemplateBuilderComponent } from './template-builder/template-builder.component';

const routes: Routes = [
  { path: '', component: ChannelComponent, },
  { path: 'add', component: ChannelFormComponent, },
  { path: 'edit/:idChannel', component: ChannelFormComponent, },
  { path: 'view/:idChannel', component: ChannelViewComponent, },
  { path: 'redirectInstagram', component: ChannelRedirectInstagramComponent, },
  { path: 'redirectMessenger', component: ChannelRedirectMessengerComponent, },
  // WhatsApp Cloud API template builder — SPEC-2026-08-whatsapp-cloud-api-template-builder.
  { path: 'templates/:idChannel/new', component: TemplateBuilderComponent, canDeactivate: [pendingChangesGuard], },
  { path: 'templates/:idChannel/edit/:idTemplate', component: TemplateBuilderComponent, canDeactivate: [pendingChangesGuard], },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChannelRoutingModule { }
